export const LIST_STALE_TIME = 1000 * 60;
export const DEFAULT_GET_STALE_TIME = 1000 * 60;
